import { render, staticRenderFns } from "./NewSidebar.vue?vue&type=template&id=9db9cb88"
import script from "./NewSidebar.vue?vue&type=script&lang=ts"
export * from "./NewSidebar.vue?vue&type=script&lang=ts"
import style0 from "./NewSidebar.vue?vue&type=style&index=0&id=9db9cb88&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports